module.exports = __webpack_public_path__ + "img/logo.dd89ebf2.svg";